export default "__VITE_ASSET__RlAfsa7i__"